<template>
  <el-dialog
    title="照片预览"
    :visible="dialogFormVisiblePhoto"
    width="85vw"
    top="6vh"
    :lock-scroll="false"
    :close-on-press-escape="true"
    :close-on-click-modal="true"
    @close="closeDialog"
  >
    <div v-if="pics.length > 0" class="check-photo">
      <div class="check-photo-toolbar">
        <span class="check-photo-count">{{ currentIndex + 1 }} / {{ pics.length }}</span>
        <el-button
          type="text"
          :disabled="!currentImage"
          @click="openCurrentImage"
        >新窗口打开原图</el-button>
      </div>
      <div class="chkimg">
        <div v-if="imgLoadError" class="img-fallback">图片加载失败</div>
        <el-image
          v-else
          class="main-image"
          :src="currentImage"
          :preview-src-list="pics"
          :initial-index="currentIndex"
          fit="contain"
          @error="handleMainImageError"
        >
          <div slot="placeholder" class="img-loading">加载中...</div>
        </el-image>
      </div>
      <ul class="tab-img">
        <li
          v-for="(item, index) in pics"
          :key="`${item}-${index}`"
          :class="{ active: index === currentIndex }"
          @click="handleClickTag(index)"
        >
          <el-image :src="item" fit="cover">
            <div slot="error" class="thumb-fallback">加载失败</div>
          </el-image>
        </li>
      </ul>
    </div>
    <div v-else class="no-pics">暂无图片</div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="closeDialog">关 闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props: {
    pics: {
      type: Array,
      default: () => [],
    },
    dialogFormVisiblePhoto: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      currentIndex: 0,
      imgLoadError: false,
    };
  },
  computed: {
    currentImage() {
      return this.pics[this.currentIndex] || "";
    },
  },
  methods: {
    handleClickTag(index) {
      this.currentIndex = index;
      this.imgLoadError = false;
    },
    closeDialog() {
      this.$emit("func");
    },
    handleMainImageError() {
      this.imgLoadError = true;
    },
    openCurrentImage() {
      if (!this.currentImage) return;
      window.open(this.currentImage, "_blank");
    },
  },
  watch: {
    pics: {
      handler(newVal) {
        if (Array.isArray(newVal) && newVal.length > 0) {
          this.currentIndex = 0;
          this.imgLoadError = false;
          return;
        }
        this.currentIndex = 0;
        this.imgLoadError = false;
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>

<style>
.check-photo {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.check-photo-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.check-photo-count {
  color: #606266;
}
.chkimg {
  height: 65vh;
  border: 1px solid #ebeef5;
  border-radius: 6px;
  background: #f8f9fb;
  overflow: hidden;
}
.chkimg .main-image,
.chkimg .el-image {
  width: 100%;
  height: 100%;
}
.tab-img {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  max-height: 170px;
  overflow-y: auto;
  margin: 0;
  padding: 0;
}
.tab-img li {
  width: 92px;
  height: 92px;
  border: 2px solid transparent;
  border-radius: 4px;
  overflow: hidden;
  list-style: none;
  cursor: pointer;
}
.tab-img li.active {
  border-color: #409eff;
}
.tab-img .el-image {
  width: 100%;
  height: 100%;
}
.no-pics {
  text-align: center;
  color: #909399;
  padding: 30px 0;
}
.img-loading,
.img-fallback,
.thumb-fallback {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #909399;
  font-size: 14px;
}
</style>